<template>
    <div class="wrapper-button" style="gap: 8px">
        <CompassTooltip :arrow="false" :content="textTooltipReschedule">
            <ActivitiesRescheduleDatePicker
                :value="activity.date"
                placement="bottom-start"
                @update:value="onUpdateDueDate"
            >
                <CompassIconButton
                    icon="calendar-reschedule"
                    :size="sizeButton"
                    data-bot="activities-listing__action-reschedule-icon-button"
                    :disabled="!canReschedule"
                />
            </ActivitiesRescheduleDatePicker>
        </CompassTooltip>
        <ActivitiesStatusIconButton
            :canUpdate="activity.acl.can_be_updated"
            :isActive="activity.status.done"
            :disabled="!canUpdateStatusAsDone"
            :pending="activity.status.pending"
            :type="activity.type"
            :size="sizeButton"
            @clicked="$emit('updateStatus')"
        />
        <CompassMenu
            v-if="isActivityPage"
            customClass="activity-actions__more-actions-menu"
            placement="bottom-end"
        >
            <CompassIconButton icon="action" />
            <template #dropdown>
                <CompassMenuItem
                    :disabled="!activity.acl.can_be_updated"
                    :label="$t.__('common.actions.edit')"
                    data-bot="activities-listing__action-edit-icon-button"
                    :tooltipProps="{
                        disabled: activity.acl.can_be_updated,
                        arrow: false,
                        content: $t.__('common.labels.no_permissions_to_perform_this_action'),
                    }"
                    @click="editActivity"
                />
                <CompassMenuItem
                    v-if="isActivityPage"
                    :disabled="!activity.acl.can_be_deleted"
                    :label="$t.__('common.actions.delete')"
                    data-bot="activities-listing__action-delete-icon-button"
                    :tooltipProps="{
                        disabled: activity.acl.can_be_deleted,
                        arrow: false,
                        content: $t.__('common.labels.no_permissions_to_perform_this_action'),
                    }"
                    @click="onDeleteActivity"
                />
            </template>
        </CompassMenu>
    </div>
</template>

<script>
import activitiesListingMixins from 'mixins/activities/activitiesListingMixins';
import ActivitiesStatusIconButton from 'vcomponents/activities/statusIconButton/ActivitiesStatusIconButton.vue';
import ActivitiesRescheduleDatePicker from 'vcomponents/activities/ActivitiesRescheduleDatePicker.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: popupMapActions } = createNamespacedHelpers('popupPanel');
const { mapGetters: userMapGetters } = createNamespacedHelpers('user');
export default {
    components: {
        ActivitiesStatusIconButton,
        ActivitiesRescheduleDatePicker,
    },
    mixins: [activitiesListingMixins],
    props: {
        activity: {
            type: Object,
            required: true,
        },
        isActivityPage: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            canUpdateStatusAsDone: false,
        };
    },
    computed: {
        ...userMapGetters(['getPermissions', 'getCurrentUserId']),
        canReschedule() {
            const allowReschedule = [
                this.ACTIVITY_TYPES.TASK,
                this.ACTIVITY_TYPES.PHONECALL,
            ].includes(this.activity.type);
            return (
                (this.activity.status.done || allowReschedule) && this.activity.acl.can_be_updated
            );
        },
        sizeButton() {
            return this.isActivityPage ? 'medium' : 'small';
        },
        textTooltipReschedule() {
            return this.activity.acl.can_be_updated
                ? this.$t.__('common.actions.reschedule')
                : this.$t.__('common.labels.no_permissions_to_perform_this_action');
        },
    },
    created() {
        this.canUpdateStatusAsDone =
            [this.ACTIVITY_TYPES.TASK, this.ACTIVITY_TYPES.PHONECALL].includes(
                this.activity.type,
            ) && this.activity.acl.can_be_updated;
    },
    methods: {
        ...popupMapActions(['open']),
        onUpdateDueDate(rescheduledDate) {
            EventBus.emit('activities-listing-table:updateDueDate', {
                activity: this.activity,
                rescheduledDate,
            });
        },
        editActivity() {
            if (this.$store.state.popupPanel?.activityDetailPanel?.display) {
                this.$store.dispatch('popupPanel/close', { key: 'activityDetailPanel' });
            }

            switch (this.activity.type) {
                case this.ACTIVITY_TYPES.TASK:
                case this.ACTIVITY_TYPES.EVENT:
                    Activities.openActivityForm(
                        this.activity.activityId,
                        this.activity?.related?.at(0)?.id ?? null,
                        this.activity?.related?.at(0)?.type ?? null,
                        () => EventBus.emit('activities-listing-table:refresh'),
                        this.activity.type,
                    );
                    break;
                case this.ACTIVITY_TYPES.PHONECALL:
                    Activities.openPhoneCallForm(
                        this.activity.activityId,
                        null,
                        null,
                        () => EventBus.emit('activities-listing-table:refresh'),
                        this.activity.status?.done ?? false,
                    );
                    break;
                default: {
                    this.openLegacyForm(this.activity);
                }
            }
            if (this.$store.state['activitiesStores']) {
                this.$store.dispatch('activitiesStores/updateActivitySelected', this.activity);
            }
        },
        onDeleteActivity() {
            this.open({
                key: 'activityDeleteDialog',
                props: {
                    activity: this.activity,
                    callback: () => EventBus.emit('activities-listing-table:refresh'),
                },
            });
        },
    },
};
</script>

<style scoped lang="scss">
.activities-listing__cell-actions {
    .wrapper-button {
        display: flex;
    }
}
</style>
<style lang="scss">
#compass-menu-container {
    .activity-actions__reschedule-menu,
    .activity-actions__more-actions-menu {
        z-index: 3;
    }
}
</style>
